<script>
  import { markRaw } from 'vue';

  import Layout from "@/layouts/main.vue";
  import PageHeader from "@/components/page-header";

  import MixinList from '@/Libs/Mixins/List.js';

  import FilterFormSidebar from './Part/FilterFormSidebar.vue';
  import SignInForm from "./Part/SignInForm.vue";

  export default {
    mixins: [MixinList],
    components: {
      Layout,
      PageHeader
    },
    data() {
      return {
        filterFormSidebar: markRaw(FilterFormSidebar),
        signInForm: markRaw(SignInForm),

        routeName: 'reservation',
      }
    },
    mounted() {

    },
    methods: {
      async _search() {
        var search = this.search;

        if (!search.order_by) {
          search.order_by = 'created_at';
          search.sort_by = 'desc';
        }

        return await this.$api.Reservation.all(search);
      },
      async _delete(params) {
        return await this.$api.Reservation.delete(params);
      },
      async _restore(id) {
        return await this.$api.Reservation.restore(id);
      },
      async setStatus(params) {
        var vm = this;
        this.$loading.on(['reservation_list_status', params.id].join('_'));

        try {
          var resp = await this.$api.Reservation.status(params);
          var data = resp.data;

          vm._doSearch();

          this.$flash.success(data.message);
        } catch (err) {
          this.$flash.error(err.response.data.message);
        }
        this.$loading.off(['reservation_list_status', params.id].join('_'));
      },
      accept(id) {
        this.setStatus({ id: id, status: 'approved' });
      },
      reject(id) {
        this.setStatus({ id: id, status: 'reject' });
      },
      cancel(id) {
        this.setStatus({ id: id, status: 'cancel' });
      },
      signin(id, ref_no = null) {
        this.setStatus({ id: id, ref_no: ref_no, status: 'going' });
      },
      signout(id) {
        this.setStatus({ id: id, status: 'done' });
      },
      onSuccessSignIn() {
        var vm = this;

        vm._doSearch();
      }
    },
  };
</script>

<template>
  <Layout>
    <PageHeader
      :title="search.is_deleted == 0 || search.is_deleted == null ? $t('reservation.title.list') : $t('reservation.title.list') + '' + $t('basic.title.deleted')"
      :pageTitle="$t('menu.sub_header.dashboard')" />

    <BRow class="g-4 align-items-center mb-3">
      <BCol sm="auto">
        <div class="d-flex flex-wrap align-items-start gap-2">
          <BButton type="button" variant="success" @click="$router.push({ name: 'reservation-create' })"
            v-if="(search.is_deleted == 0 || search.is_deleted == null) && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create')))">
            <i class="mdi mdi-plus-thick align-bottom me-1"></i> {{ $t('basic.btn.add') }}
          </BButton>
          <btn-sidebar variant="info"
            v-if="(search.is_deleted == 0 || search.is_deleted == null) && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create')))"
            :sidebar="signInForm" :success="onSuccessSignIn">
            <i class="mdi mdi-qrcode-scan align-bottom me-1"></i> {{ $t('reservation.btn.signin') }}
          </btn-sidebar>
          <BButton type="button" variant="dark"
            @click="$router.push({ name: routeName, query: { page: 1, is_deleted: 1 } })"
            v-if="(search.is_deleted == 0 || search.is_deleted == null) && ($ac.hasAccess('reservation_full_access'))">
            <i class="mdi mdi-delete-empty-outline align-bottom me-1"></i> {{ $t('basic.btn.trash') }}
          </BButton>
          <BButton type="button" variant="info" class="add-btn" id="trash-btn"
            v-if="search.is_deleted == 1 && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_list')))"
            :to="{ name: routeName, query: { page: 1, is_deleted: 0 } }">
            <i class="mdi mdi-keyboard-backspace align-bottom me-1"></i> {{ $t('basic.btn.list') }}
          </BButton>
          <btn-sidebar variant="primary"
            v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_list')))"
            :sidebar="filterFormSidebar" :success="onSubmitFilter">
            <i class="mdi mdi-filter-outline align-bottom me-1"></i> {{ $t('basic.btn.filter') }}
          </btn-sidebar>
          <BButton type="button" variant="danger" class="add-btn" @click="clear"
            v-if="hasActiveFilter && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_list')))">
            <i class="mdi mdi-close-thick align-bottom me-1"></i> {{ $t('basic.btn.clear') }}
          </BButton>
        </div>
      </BCol>
      <BCol sm>
        <div class="d-flex justify-content-sm-end">
          <div class="search-box ms-2">
            <b-form @submit="doSearch()">
              <input type="text" class="form-control" v-model="search.keyword"
                :placeholder="$t('filter.placeholder.keyword')" />
              <i class="mdi mdi-magnify search-icon"></i>
            </b-form>
          </div>
        </div>
      </BCol>
    </BRow>

    <BRow>
      <BCol lg="12">
        <BCard no-body>
          <BCardBody>
            <div>
              <div class="table-responsive table-card position-relative">
                <loading :loading="$loading.get([routeName, 'list'].join('_'))" variant="dark" type="block">
                  <table class="table align-middle table-hover table-nowrap mb-0">
                    <thead class="table-light">
                      <tr>
                        <th style="width: 10px;">{{ $t('basic.label.line') }}</th>
                        <th class="cursor-pointer" @click="sortBy('ref_no')">
                          <div class="d-flex justify-content-between align-items-center">
                            <span>{{ $t('reservation.label.ref_no') }}</span>
                            <sortable :order="$orderBy.getClass('ref_no')" />
                          </div>
                        </th>
                        <th class="cursor-pointer" @click="sortBy('user')">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ $t('reservation.label.user') }}
                            <sortable :order="$orderBy.getClass('user')" />
                          </div>
                        </th>
                        <th class="cursor-pointer" @click="sortBy('store')">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ $t('reservation.label.store') }}
                            <sortable :order="$orderBy.getClass('store')" />
                          </div>
                        </th>
                        <th class="cursor-pointer" @click="sortBy('branch')">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ $t('reservation.label.branch') }}
                            <sortable :order="$orderBy.getClass('branch')" />
                          </div>
                        </th>
                        <th class="cursor-pointer" @click="sortBy('room')">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ $t('reservation.label.room') }}
                            <sortable :order="$orderBy.getClass('room')" />
                          </div>
                        </th>
                        <th class="cursor-pointer" @click="sortBy('stuff')">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ $t('reservation.label.stuff') }}
                            <sortable :order="$orderBy.getClass('stuff')" />
                          </div>
                        </th>
                        <th class="cursor-pointer" @click="sortBy('booked')">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ $t('reservation.label.date') }}
                            <sortable :order="$orderBy.getClass('booked')" />
                          </div>
                        </th>
                        <th style="width: 150px;">{{ $t('basic.label.action') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tr, index) in list" :key="index" :class="[{
                        'bg-light-subtle': tr.status_name == 'draft',
                        'bg-warning-subtle': tr.status_name == 'pending',
                        'bg-success-subtle': tr.status_name == 'approved',
                        'bg-info-subtle': tr.status_name == 'going',
                        'bg-dark-subtle': tr.status_name == 'done',
                        'bg-danger-subtle': tr.status_name == 'reject',
                        'bg-danger-subtle': tr.status_name == 'cancel',
                        'bg-danger-subtle': tr.status_name == 'expired'
                      },
                      (search.is_deleted == 0 || search.is_deleted == null) && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_show'))) ? 'cursor-pointer' : ''
                      ]" @click="(search.is_deleted == 0 || search.is_deleted == null)
                        && ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_show')))
                        && $router.push({ name: 'reservation-detail', params: { id: tr.id } })">
                        <td>{{ index + 1 }}</td>
                        <td>
                          {{ tr.ref_no }}<br>
                          <BBadge variant="light" v-if="tr.status_name == 'draft'">{{ tr.status }}</BBadge>
                          <BBadge variant="warning" v-if="tr.status_name == 'pending'">{{ tr.status }}</BBadge>
                          <BBadge variant="success" v-if="tr.status_name == 'approved'">{{ tr.status }}</BBadge>
                          <BBadge variant="info" v-if="tr.status_name == 'going'">{{ tr.status }}</BBadge>
                          <BBadge variant="dark" v-if="tr.status_name == 'done'">{{ tr.status }}</BBadge>
                          <BBadge variant="danger" v-if="tr.status_name == 'reject'">{{ tr.status }}</BBadge>
                          <BBadge variant="danger" v-if="tr.status_name == 'cancel'">{{ tr.status }}</BBadge>
                          <BBadge variant="danger" v-if="tr.status_name == 'expired'">{{ tr.status }}</BBadge>
                        </td>
                        <td>
                          {{ tr.user_name }}
                          <div><span class="text-body-secondary">{{ tr.user_phone }}</span></div>
                        </td>
                        <td>
                          {{ tr.store }}
                          <br><span class="text-body-secondary">{{ tr.store_ref_no }}</span>
                        </td>
                        <td>
                          {{ tr.branch }}
                          <br><span class="text-body-secondary">{{ tr.branch_ref_no }}</span>
                        </td>
                        <td>
                          {{ tr.room }}
                          <br><span class="text-body-secondary">{{ tr.room_ref_no }}</span>
                        </td>
                        <td>
                          {{ tr.stuff }}
                          <br><span class="text-body-secondary">{{ tr.stuff_ref_no }}</span>
                        </td>
                        <td>
                          <span>{{ $t('reservation.label.booked') }}</span>: <span>{{ $dateFormat.datetime(tr.booked_at)
                          }}</span><br>
                          <span class="text-body-secondary">{{ $t('reservation.label.expired') }}</span>: <span>
                            <BBadge variant="danger">{{ $dateFormat.datetime(tr.expired_at) }}</BBadge>
                          </span><br>
                          <span class="text-body-secondary">{{ $t('reservation.label.created') }}:
                            {{ $dateFormat.datetime(tr.created_at) }}</span>
                        </td>
                        <td @click.stop>
                          <BDropdown variant="info" size="sm" class="me-1" strategy="fixed" v-if="search.is_deleted == 0 || search.is_deleted == null &&
                            ($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(tr.branch_id) || $ac.hasAccessStore(tr.store_id)))) &&
                            (['draft', 'pending', 'approved', 'going'].includes(tr.status_name))" :toggle-class="{
                              'no-caret': $loading.get(['reservation_list_status', tr.id].join('_'))
                            }" :disabled="$loading.get(['reservation_list_status', tr.id].join('_'))">
                            <template #button-content
                              class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                              <loading :loading="$loading.get(['reservation_list_status', tr.id].join('_'))"
                                variant="light" type="button">
                                {{ $t('reservation.btn.status') }}
                              </loading>
                            </template>
                            <BDropdownItem @click.prevent="accept(tr.id)" variant="success"
                              v-if="['draft'].includes(tr.status_name)">
                              <i class="mdi mdi-check-bold fs-16"></i> {{ $t('reservation.btn.confirm') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="accept(tr.id)" variant="success"
                              v-if="['pending'].includes(tr.status_name)">
                              <i class="mdi mdi-check-bold fs-16"></i> {{ $t('reservation.btn.accept') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="reject(tr.id)" variant="danger"
                              v-if="['pending'].includes(tr.status_name)">
                              <i class="mdi mdi-close-thick fs-16"></i> {{ $t('reservation.btn.reject') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="signin(tr.id)" variant="info"
                              v-if="['approved'].includes(tr.status_name)">
                              <i class="mdi mdi-login fs-16"></i> {{ $t('reservation.btn.signin') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="cancel(tr.id)" variant="danger"
                              v-if="['approved'].includes(tr.status_name)">
                              <i class="mdi mdi-delete-outline fs-16"></i> {{ $t('reservation.btn.cancel') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="signout(tr.id)" variant="dark"
                              v-if="['going'].includes(tr.status_name)">
                              <i class="mdi mdi-logout fs-16"></i> {{ $t('reservation.btn.signout') }}
                            </BDropdownItem>
                          </BDropdown>

                          <BDropdown variant="primary" no-caret size="sm" strategy="fixed"
                            v-if="(search.is_deleted == 0 || search.is_deleted == null) && ['draft'].includes(tr.status_name)" :toggle-class="{
                              'no-caret': $loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))
                            }"
                            :disabled="$loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))">
                            <template #button-content
                              class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                              <loading
                                :loading="$loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))"
                                variant="light" type="button">
                                {{ $t('basic.btn.action') }}
                              </loading>
                            </template>
                            <BDropdownItem :to="{ name: 'reservation-update', params: { id: tr.id } }" variant="warning"
                              v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create')))">
                              <i class="mdi mdi-pencil-outline fs-16"></i> {{ $t('basic.btn.edit') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="destroy(tr.id)" variant="danger"
                              v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_delete')))">
                              <i class="mdi mdi-delete-outline fs-16"></i> {{ $t('basic.btn.delete') }}
                            </BDropdownItem>
                          </BDropdown>

                          <BDropdown variant="primary" no-caret size="sm" strategy="fixed" v-if="search.is_deleted == 1"
                            :toggle-class="{
                              'no-caret': $loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))
                            }"
                            :disabled="$loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))">
                            <template #button-content
                              class="btn btn-primary btn-md dropdown-toggle waves-effect waves-light shadow-none">
                              <loading
                                :loading="$loading.get([routeName, 'delete', tr.id].join('_')) || $loading.get([routeName, 'restore', tr.id].join('_'))"
                                variant="light" type="button">
                                {{ $t('basic.btn.action') }}
                              </loading>
                            </template>
                            <BDropdownItem @click.prevent="restore(tr.id)" variant="success"
                              v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_restore')))">
                              <i class="mdi mdi-restore fs-16"></i> {{ $t('basic.btn.restore') }}
                            </BDropdownItem>
                            <BDropdownItem @click.prevent="destroy(tr.id, 1)" variant="danger"
                              v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_delete_permanent')))">
                              <i class="mdi mdi-eraser fs-16"></i> {{ $t('basic.btn.delete_permanent') }}
                            </BDropdownItem>
                          </BDropdown>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </loading>
              </div>
            </div>
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>
    <BRow class="mb-3">
      <BCol>
        <div>
          <pagination v-bind:model="paginator" v-on:goto="goto"
            :disabled="$loading.get([routeName, 'list'].join('_'))" />
        </div>
      </BCol>
    </BRow>
  </Layout>
</template>